import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  setUsername,
  ReloadPageFalse,
  ReloadPageTrue,
  closeWindow,
} from "./../../actions/index";
import jwt_decode from "jwt-decode";
import axios from "axios";

const SuccessPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const apiAddress = process.env.REACT_APP_SECRET;
  useEffect(() => {
    const runAsync = async () => {
      try {
        const params = new Proxy(new URLSearchParams(window.location.search), {
          get: (searchParams, prop) => searchParams.get(prop),
        });

        const token = params.token;
        const expirationDate = params.expirationDate;

        if (!token) {
          console.error("Token not found in URL.");
          return;
        }

        localStorage.setItem("gotasteClienttoken", token);
        const decoded = jwt_decode(token);

        const response = await axios.get(
          `${apiAddress}/api/GoTasteUser/GetGo5050UserInformations?userId=${decoded.UserId}`
        );

        if (response.data) {
          console.log(response.data);
          // navigate("/home"); // optionally navigate here
        }

        // Inform opener window
        if (window.opener) {
          window.opener.postMessage(true, "*");
        }

        dispatch(closeWindow(false));
      } catch (error) {
        console.error("Error in useEffect async flow:", error);
      }
    };

    runAsync();
  });
  return (
    <div>
      <h3>Success</h3>
      <button
        onClick={() => {
          dispatch(closeWindow(true));
        }}
      >
        close
      </button>
    </div>
  );
};

export default SuccessPage;
